export default function Spinner({ label }: { label?: string }) {
  return (
    <div className="text-center text-muted py-5">
      <div className="spinner-border text-success mb-3" role="status" />
      {label && <div className="small">{label}</div>}
    </div>
  );
}
